import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})

export class AuthguardCredentials {

    constructor(private router: Router, private authService: AuthService, private titleService: Title) {
    }

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        if (!this.authService.hasValidatedReset()) {
            this.router.navigate(['login']);
            return false;
        } else {
            if (route.data["title"]) {
                this.titleService.setTitle("Applicant Form | " + route.data["title"]);
            }
            return true;
        }
    }
}
